(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drinks-product--flavor-selector"] && !Shopify.designMode) return;
  try {
    function initFlavorSelectors(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const selectors = [];

  if (scope !== document && scope.matches && scope.matches('.flavor-selector')) {
    selectors.push(scope);
  }

  scope.querySelectorAll('.flavor-selector').forEach(sel => {
    selectors.push(sel);
  });

  selectors.forEach(sel => {
    if (sel.dataset.flavorSelectorInitialized === 'true') return;

    const titleSpan = sel.querySelector('h2 span');
    const options = sel.querySelectorAll('.flavor-option');
    if (!options.length) return;
    sel.dataset.flavorSelectorInitialized = 'true';

    let current = sel.querySelector('.flavor-option.is-active') || options[0];

    function getName(li) {
      const hidden = li.querySelector('.visually-hidden');
      return hidden ? hidden.textContent.trim() : '';
    }

    function getSlug(li) {
      return (li.dataset.flavor || '').trim().toLowerCase();
    }

    function applyTheme(slug) {
      sel.classList.forEach(cls => {
        if (cls.indexOf('color-') === 0) sel.classList.remove(cls);
      });
      if (slug) sel.classList.add('color-' + slug);
    }

    function preview(li) {
      if (!li || !titleSpan) return;
      titleSpan.textContent = getName(li);
      applyTheme(getSlug(li));
    }

    function commit(li) {
      options.forEach(o => {
        const active = o === li;
        o.classList.toggle('is-active', active);
        const link = o.querySelector('a');
        if (!link) return;
        if (active) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      current = li;
      preview(li);
    }

    options.forEach(li => {
      li.addEventListener('mouseenter', () => preview(li));
      li.addEventListener('mouseleave', () => preview(current));

      li.addEventListener('focusin', () => preview(li));
      li.addEventListener('focusout', () => preview(current));
    });

    // Init
    commit(current);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initFlavorSelectors(document);
  });
} else {
  initFlavorSelectors(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initFlavorSelectors(event && event.target ? event.target : document);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["where-to-buy-online"] && !Shopify.designMode) return;
  try {
    if (!window.__wtbClickBound) {
    window.__wtbClickBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.where-to-buy-online .retailer');
      if (!link) {
        return;
      }

      var retailer = link.getAttribute('data-wtb-retailer') || '';
      var product = link.getAttribute('data-wtb-product') || '';
      var productId = link.getAttribute('data-wtb-product-id') || '';
      var productTitle = link.getAttribute('data-wtb-product-title') || '';
      var productBrand = link.getAttribute('data-wtb-product-brand') || '';
      var productCategory = link.getAttribute('data-wtb-product-category') || '';
      var market = link.getAttribute('data-wtb-market') || '';
      var position = link.getAttribute('data-wtb-position') || '';
      var url = link.href;
  
      var linkDomain = '';
      try { linkDomain = new URL(url).hostname; } catch (e) {}
  
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'where_to_buy_click', {
          retailer: retailer,
          market: market,
          destination_url: url,
          link_domain: linkDomain,
          product_id: productId || product,
          product_title: productTitle,
          product_brand: productBrand,
          product_category: productCategory,
          position: parseInt(position, 10) || undefined
        });
      } else {
        // optional: helps you debug if GA isn't loaded on that page
        console.warn('gtag not available');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
